export default __webpack_public_path__ + "static/media/argentan.d1eafa4d.jpg";